import { useNavigate } from 'react-router-dom';
import { 
  getAllTrackingIds, 
  persistMetaCookiesToStorage,
  getMetaCookies 
} from '@/utils/metaCookies';  // NEW IMPORT

const useClicks = (userData, planId, newlySignedUp, planCbItem) => {
  const navigate = useNavigate();
  
  const navigateToSignUp = () => {
    if (planCbItem) localStorage.setItem(localStorageKeys.AUTO_SUBSCRIBE_WITH_PLAN, planCbItem);
    navigate('/signup');
  };

  const handleStartTrial = () => {
    if (userData.token === null) localStorage.clear();

    if (userData.token !== null || newlySignedUp) {
      window.Chargebee.registerAgain();

      // Generate a stable event ID for deduplication between pixel and CAPI
      const startTrialEventId = `start_trial_${userData.user?.email || 'unknown'}_${Date.now()}`;
      localStorage.setItem('start_trial_event_id', startTrialEventId);

      // Update cart customer with the new event ID immediately
      const instance = window?.Chargebee?.getInstance();
      const cart = instance?.getCart();
      if (cart) {
        const customerDetails = {
          id: userData.user?.email || '',
          email: userData.user?.email?.toLowerCase() || '',
          first_name: userData.user?.firstname,
          last_name: userData.user?.lastname,
          ...getAllTrackingIds()
        };
        cart.setCustomer(customerDetails);
      }

      // Fire pixel with eventID for deduplication
      window?.fbq('trackCustom', planId, {
        CustomEvent: planId
      });

      window?.fbq('track', 'StartTrial', {
        content_name: planId,
        content_category: 'subscription',
        currency: 'USD',
        value: 0,
        eventID: startTrialEventId
      });

      persistMetaCookiesToStorage();

    } else {
      navigateToSignUp();
    }
  };

  const handleStartSubscription = () => {
    window.Chargebee.registerAgain();
    const testInstance = window?.Chargebee?.getInstance();
    const cart = testInstance?.getCart();

    // Build customer details with email and name
    const customerDetails = {
      id: userData.user?.email ? userData.user?.email : '',
      email: userData.user?.email ? userData.user?.email.toLowerCase() : '',
      first_name: userData.user?.firstname,
      last_name: userData.user?.lastname
    };


    const trackingIds = getAllTrackingIds();
    
    // Merge tracking IDs into customer details
    Object.assign(customerDetails, trackingIds);
    
    // Log for debugging (remove in production)
    console.log('[useClicks] Customer details with tracking:', {
      email: customerDetails.email,
      cf_tid: customerDetails.cf_tid || 'not set',
      cf_fbp: customerDetails.cf_fbp || 'not set',
      cf_fbc: customerDetails.cf_fbc || 'not set',
    });

    cart.setCustomer(customerDetails);
  };

  return { navigateToSignUp, handleStartTrial, handleStartSubscription };
};

export default useClicks;